import React, { createContext, useEffect } from 'react';
import { useLocalStorage } from 'react-use';

type ThemeType = 'light' | 'dark';

interface ThemeValues {
  theme: ThemeType;
  setTheme: any;
}

export const ThemeContext = createContext<ThemeValues>(null!);

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useLocalStorage<ThemeType>('arco-theme', 'light');

  useEffect(() => {
    if (theme === 'dark') {
      document.body.setAttribute('arco-theme', 'dark');
    } else {
      document.body.removeAttribute('arco-theme');
    }
  }, [theme]);
  return (
    <ThemeContext.Provider
      value={{
        theme: theme || 'light',
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
